import { isFundAsset } from '@utils/helpers'
import { AssetType, PeriodEnum } from 'interfaces'

export const getDefaultPeriodForAsset = (type: AssetType): PeriodEnum => {
  return isFundAsset(type) ? PeriodEnum.year : PeriodEnum.day
}
